import {
  Autocomplete,
  Box,
  Chip,
  Container,
  Divider,
  FormLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import React, { useEffect, useState } from "react";
import GlobalHeader from "../../../components/GlobalHeader";
import useSnack from "../../../hooks/useSnack";
import SnackAlert from "../../../components/SnackAlert";
import { useUser } from "../../../hooks/useUser";
import styled from "@emotion/styled";
import useApi from "../../../hooks/useApi";
//icons
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import countries from "../../../utils/countries";
import { TIPOS_DIFUSOR } from "../../../utils/tiposDifusor";
import defaultBanner from "../../../assets/portadaProductor2.jpg";
import {
  FaSpotify,
  FaFacebook,
  FaYoutube,
  FaInstagram,
  FaTiktok,
  FaTwitter,
  FaTwitch,
  FaMailBulk,
} from "react-icons/fa";
import { MdLiveTv } from "react-icons/md";
import useGeneros from "../../../hooks/useGeneros";
import EliminarCuenta from "../../../components/EliminarCuenta";
import WhatsappConfig from "../../../components/WhatsappConfig";
import TelegramConfig from "../../../components/TelegramConfig";
import SubirImagenPerfil from "../../../components/SubirImagenPerfil";

const initForm = {
  nombre_media: "",
  tipo: "",
  pais: "",
  descripcion: "",
  pagina_web: "",
  paypal_email: "",
  facebook: "",
  instagram: "",
  youtube: "",
  spotify: "",
  tiktok: "",
  twitch: "",
  kick: "",
  rfc: "",
  clabe_bancaria: "",
  nombre_cuenta_bancaria: "",
};

const initFormPassword = {
  password: "",
  confirmPassword: "",
};

// Pese al nombre, son los tipos de DIFUSOR; se conserva para no tocar el uso.
const tiposArtista = TIPOS_DIFUSOR;

const countryOptions = Object.entries(countries).map(([key, value]) => ({
  value: key,
  label: value,
}));

const StyledButton = styled(LoadingButton)(({ theme }) => ({
  borderRadius: 8,
  textTransform: "none",
}));

const EditProfileProducer = () => {
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const { user, updateUser } = useUser();
  const { loadApi, loadingApi } = useApi();
  const navigate = useNavigate();
  const generos = useGeneros();
  const generoOptions = generos.map((item) => ({
    value: item,
    label: item,
  }));
  //States
  const [form, setForm] = useState(initForm);
  const [formPassword, setFormPassword] = useState(initFormPassword);
  const [tags, setTags] = useState([]);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [musicalGenders, setMusicalGenders] = useState(generoOptions);

  const [selectedFiles, setPreviewImage] = useState([]);
  const [bannerImgState, setBannerImgState] = useState(null);
  //UseEffect
  useEffect(() => {
    const g = user?.profile?.generos_musicales;
    const tagsArray = Array.isArray(g)
      ? g
      : typeof g === "string"
        ? (() => {
            try {
              return JSON.parse(g);
            } catch {
              return [];
            }
          })()
        : [];
    setTags(tagsArray);
    setPreviewImage(user?.profile?.bannerimg || defaultBanner);
  }, [user?.profile?.generos_musicales, user?.profile?.bannerimg]);

  // La lista de géneros es administrable y llega por API después del primer
  // render; sin esto el catálogo quedaría congelado en la lista estática de
  // respaldo y los géneros agregados desde el panel nunca aparecerían.
  useEffect(() => {
    setMusicalGenders(generos.map((item) => ({ value: item, label: item })));
  }, [generos]);

  //cambiar datos del state
  const handleInputChange = ({ target }, setState) => {
    const { name, value } = target;
    setState((adata) => ({
      ...adata,
      [name]: value,
    }));
  };

  //Cambiar datos del autocomplete
  const handleAutocompleteChange = (e, name) => {
    if (name) setForm((adata) => ({ ...adata, pais: name.value }));
    else setForm((adata) => ({ ...adata, pais: "mx" }));
  };

  //Borrar un genero musical
  const onDeleteTag = (value) => {
    setTags((prevTags) =>
      Array.isArray(prevTags) ? prevTags.filter((tag) => tag !== value) : []
    );
  };

  //Agregar Tag
  const handleAddTag = (value) => {
    const currentTags = Array.isArray(tags) ? tags : [];
    if (currentTags.length >= 10) {
      showSnack("¡Maximo 10 generos!", "warning");
      return;
    }
    if (currentTags.includes(value)) {
      showSnack("¡Ya ingresaste este género!", "warning");
      return;
    }
    setTags((prev) => [...(Array.isArray(prev) ? prev : []), value]);
  };

  const handleChangeImg = async ({ target }) => {
    const [file] = target.files;
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
      setBannerImgState(file);
    }
  };

  const submitImage = async ({ target }) => {
    const file = bannerImgState;
    if(file == null) return;
    if (file) {
      try {
        const { data } = await loadApi(
          "productor/profile",
          true,
          "put",
          { bannerimg: file },
          true
        );

        showSnack(data.message);
        updateUser();
        setBannerImgState(null);
      } catch (error) {
        showSnack(error.message, "error");
      }
    } else {
      setPreviewImage(null);
    }
  };


  //Buscar tags
  const handleSearchTags = (value) => {
    clearTimeout(typingTimeout);
    if (value.trim()) {
      const newTypingTimeout = setTimeout(() => {
        const filteredMusicalGender = generoOptions.filter((option) =>
          option.value.toLowerCase().includes(value.toLowerCase())
        );
        setMusicalGenders(filteredMusicalGender);
      }, 500);

      setTypingTimeout(newTypingTimeout);
    } else {
      setMusicalGenders(generoOptions);
    }
  };

  //Cambiar información del usuario
  const handleSubmitUser = async (e, oldBody) => {
    e.preventDefault();
    try {
      let body;
      if (Object.keys(oldBody).includes("password")) {
        if (oldBody.password === oldBody.confirmPassword)
          body = { password: oldBody.password };
        else {
          return showSnack("las contraseñas no coinciden", "error");
        }
      } else {
        body = oldBody;
      }
      const { data } = await loadApi("user", true, "put", body);
      showSnack(data.message);
      updateUser();
    } catch (error) {
      showSnack(error.message, "error");
    }
  };

  //Cambiar información publica
  const handleSubmitProfile = async (e) => {
    e.preventDefault();
    const body = form;
    if (body.paypal_email) body.paypal_email = body.paypal_email.toLowerCase();
    if (Array.isArray(tags) && tags.length > 0) body["generos_musicales"] = tags;
    try {
      const { data } = await loadApi(
        "productor/profile",
        true,
        "put",
        body,
        true
      );
      showSnack(data.message);
      updateUser();
    } catch (error) {
      showSnack(error.message, "error");
    }
  };

  return (
    <Stack bgcolor="#f0f1f7" minHeight="calc(100vh - 40px)" pb={5}>
      <GlobalHeader />
      <Container maxWidth="md">
        <Stack direction="row" spacing={1} alignItems="center" mb={1}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackOutlinedIcon />
          </IconButton>
          <Typography variant="h6" color="#3b3b3b">
            Editar perfil
          </Typography>
        </Stack>
        {/* Edit cart */}
        <Stack
          bgcolor="#ffffff"
          sx={{
            borderRadius: "20px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          }}
          py={4}
          px={{ xs: 1, sm: 3 }}
        >
          {/* User info (solo lectura: nombre de usuario y email son inmutables) */}
          <Typography variant="subtitle1" color="#3b3b3b">
            Información de usuario
          </Typography>
          <Divider />
          <Stack gap={2} py={2}>
            <TextField
              size="small"
              name="name"
              type="text"
              label="Nombre cuenta"
              disabled
              helperText="El nombre de usuario no se puede modificar"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">@</InputAdornment>
                ),
              }}
              defaultValue={user?.name}
              sx={{
                maxWidth: "400px",
              }}
            />
            <TextField
              size="small"
              name="username"
              type="email"
              label="Correo electronico"
              disabled
              defaultValue={user?.username}
              sx={{
                maxWidth: "400px",
              }}
            />
          </Stack>


          {/* info bancaria */}
          <Typography variant="subtitle1" color="#3b3b3b">
            Información Bancaria
          </Typography>
          <Divider />
          <Stack
            component="form"
            role="form"
            gap={3}
            py={3}
            onSubmit={handleSubmitProfile}
          >
          <TextField
              size="small"
              name="nombre_cuenta_bancaria"
              type="text"
              label="Nombre cuenta bancaria"
              onChange={(e) => handleInputChange(e, setForm)}
              defaultValue={user?.profile?.nombre_cuenta_bancaria}
              sx={{
                maxWidth: "400px",
              }}
            />

            <TextField
              size="small"
              name="clabe_bancaria"
              type="text"
              label="CLABE"
              onChange={(e) => handleInputChange(e, setForm)}
              defaultValue={user?.profile?.clabe_bancaria}
              sx={{
                maxWidth: "400px",
              }}
            />
            <TextField
              inputProps={{ style: { textTransform: "uppercase" } }}
              size="small"
              name="rfc"
              type="text"
              label="RFC"
              onChange={(e) => handleInputChange(e, setForm)}
              defaultValue={user?.profile?.rfc}
              sx={{
                maxWidth: "400px",
              }}
            />
            <Stack alignItems="end">
              <StyledButton
                loading={loadingApi.includes("put__user")}
                loadingPosition="start"
                variant="outlined"
                startIcon={<SaveOutlinedIcon />}
                type="submit"
              >
                Guardar
              </StyledButton>
            </Stack>
          </Stack>    


          {/* Profile info */}
          <Typography variant="subtitle1" color="#3b3b3b">
            Información publica
          </Typography>
          <Divider />
          <Stack
            component="form"
            role="form"
            gap={2}
            py={2}
            onSubmit={handleSubmitProfile}
          >
            <TextField
              size="small"
              name="nombre_media"
              type="text"
              label="Nombre"
              onChange={(e) => handleInputChange(e, setForm)}
              defaultValue={user?.profile?.nombre_media}
              sx={{
                maxWidth: "400px",
              }}
            />
            <Stack direction="row" gap={1} width="100%" maxWidth="400px">
              <Stack
                justifyContent="center"
                p={1}
                border=".5px solid #00000040"
                borderRadius={1}
              >
                <Box
                  component="img"
                  src={`https://flagcdn.com/${
                    form.pais || user?.profile?.pais
                  }.svg`}
                  alt="País"
                  width="30px"
                  height="20px"
                />
              </Stack>
              <Autocomplete
                disablePortal
                disableClearable
                value={
                  countryOptions.find(
                    (o) =>
                      o.value === (form.pais || user?.profile?.pais) ||
                      o.label === (form.pais || user?.profile?.pais)
                  ) || null
                }
                onChange={handleAutocompleteChange}
                options={countryOptions}
                isOptionEqualToValue={(a, b) => a?.value === b?.value}
                fullWidth
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" size="small" />
                )}
              />
            </Stack>
            <TextField
              size="small"
              name="descripcion"
              type="text"
              label="Descripcion"
              multiline={true}
              rows={7}
              onChange={(e) => handleInputChange(e, setForm)}
              defaultValue={user?.profile?.descripcion}
              sx={{
                maxWidth: "400px",
              }}
            />
            <Stack maxWidth="400px">
              <FormLabel sx={{ color: "grayText" }}>
                Tipo de difusor
              </FormLabel>
              <Select
                defaultValue={user?.profile?.tipo}
                onChange={(e) => handleInputChange(e, setForm)}
                name="tipo"
                sx={{ fontWeight: "400" }}
                size="small"
              >
                {tiposArtista.map((item, i) => (
                  <MenuItem key={i} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
            {/* Musical gender */}
            <Stack maxWidth="400px" gap={1}>
              <FormLabel sx={{ color: "grayText", fontWeight: 600, mb: 2 }}>
                Géneros musicales:
              </FormLabel>
              <Stack direction="row" gap={1} flexWrap="wrap">
                {(Array.isArray(tags) ? tags : []).map((item, i) => (
                  <Chip
                    label={item}
                    key={i}
                    onDelete={() => onDeleteTag(item)}
                    size="small"
                  />
                ))}
              </Stack>
              <TextField
                size="small"
                placeholder="Busca tu genero aquí"
                onKeyUp={(e) => handleSearchTags(e.target.value)}
              />
              <Stack
                width="100%"
                maxHeight="400px"
                p={1}
                bgcolor="#f0f1f7"
                sx={{
                  boxSizing: "border-box",
                  overflowY: "auto",
                }}
                borderRadius={2}
                flexWrap="wrap"
                direction="row"
                gap={1}
                className="tagsList"
              >
                {musicalGenders.map((item, i) => (
                  <Chip
                    label={item.value}
                    key={i}
                    onClick={() => handleAddTag(item.value)}
                  />
                ))}
              </Stack>
            </Stack>
            {/* Social network */}
            <Stack maxWidth="400px" gap={3}>
              <FormLabel sx={{ color: "grayText", fontWeight: 600 }}>
                Redes Sociales y contacto:
              </FormLabel>
              <Stack gap={2}>
                <TextField
                  size="small"
                  name="email_contacto"
                  type="text"
                  label="Email de contacto"
                  onChange={(e) => handleInputChange(e, setForm)}
                  defaultValue={user?.profile?.email_contacto}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaMailBulk style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  size="small"
                  name="facebook"
                  type="text"
                  label="Cuenta de facebook"
                  onChange={(e) => handleInputChange(e, setForm)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaFacebook style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                  defaultValue={user?.profile?.facebook}
                />
                <TextField
                  size="small"
                  name="instagram"
                  type="text"
                  label="Cuenta de instagram"
                  onChange={(e) => handleInputChange(e, setForm)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaInstagram style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                  defaultValue={user?.profile?.instagram}
                />
                <TextField
                  size="small"
                  name="youtube"
                  type="text"
                  label="Cuenta de youtube"
                  onChange={(e) => handleInputChange(e, setForm)}
                  defaultValue={user?.profile?.youtube}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaYoutube style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  size="small"
                  name="spotify"
                  type="text"
                  label="Cuenta de spotify"
                  onChange={(e) => handleInputChange(e, setForm)}
                  defaultValue={user?.profile?.spotify}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaSpotify style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  size="small"
                  name="tiktok"
                  type="text"
                  label="Cuenta de tiktok"
                  onChange={(e) => handleInputChange(e, setForm)}
                  defaultValue={user?.profile?.tiktok}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaTiktok style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  size="small"
                  name="twitter"
                  type="text"
                  label="Cuenta de X (Twitter)"
                  onChange={(e) => handleInputChange(e, setForm)}
                  defaultValue={user?.profile?.twitter}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaTwitter style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  size="small"
                  name="twitch"
                  type="text"
                  label="Cuenta de Twitch"
                  onChange={(e) => handleInputChange(e, setForm)}
                  defaultValue={user?.profile?.twitch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FaTwitch style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  size="small"
                  name="kick"
                  type="text"
                  label="Cuenta de Kick"
                  onChange={(e) => handleInputChange(e, setForm)}
                  defaultValue={user?.profile?.kick}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MdLiveTv style={{ color: "#F27224" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
            </Stack>
            {/* Links and payments */}
            <Stack maxWidth="400px" gap={2}>
              <FormLabel sx={{ color: "grayText", fontWeight: 600, mb: 1 }}>
                Links y pagos:
              </FormLabel>
              <TextField
                size="small"
                name="paypal_email"
                type="email"
                label="Email de paypal"
                onChange={(e) => handleInputChange(e, setForm)}
                defaultValue={user?.profile?.paypal_email}
              />
              <TextField
                size="small"
                name="pagina_web"
                type="text"
                label="Pagina web"
                onChange={(e) => handleInputChange(e, setForm)}
                defaultValue={user?.profile?.pagina_web}
              />
            </Stack>
            <Stack alignItems="end">
              <StyledButton
                loading={loadingApi.includes("put__productor/profile")}
                loadingPosition="start"
                variant="outlined"
                startIcon={<SaveOutlinedIcon />}
                type="submit"
              >
                Guardar
              </StyledButton>
            </Stack>
          </Stack>
          {/* Change password */}
          <Typography variant="subtitle1" color="#3b3b3b">
            Cambiar contraseña
          </Typography>
          <Divider />
          <Stack
            component="form"
            role="form"
            gap={2}
            py={2}
            onSubmit={(e) => handleSubmitUser(e, formPassword)}
          >
            <TextField
              size="small"
              name="password"
              type="password"
              label="Nueva contraseña"
              onChange={(e) => handleInputChange(e, setFormPassword)}
              sx={{
                maxWidth: "400px",
              }}
            />
            <TextField
              size="small"
              name="confirmPassword"
              type="password"
              label="Confirmar nueva contraseña"
              onChange={(e) => handleInputChange(e, setFormPassword)}
              sx={{
                maxWidth: "400px",
              }}
            />
            <Stack alignItems="end">
              <StyledButton
                loading={loadingApi.includes("put__user")}
                loadingPosition="start"
                variant="outlined"
                startIcon={<SaveOutlinedIcon />}
                type="submit"
              >
                Guardar
              </StyledButton>
            </Stack>
          </Stack>

          {/* Imágenes: foto de perfil y banner */}
          <Typography variant="subtitle1" color="#3b3b3b">
            Imágenes
          </Typography>
          <Divider />
          <Stack gap={4} py={3}>
            <SubirImagenPerfil
              tipo="profileimg"
              endpoint="productor/profile"
              currentImage={user?.profile?.profileimg}
              showSnack={showSnack}
            />
            <SubirImagenPerfil
              tipo="bannerimg"
              endpoint="productor/profile"
              currentImage={user?.profile?.bannerimg}
              showSnack={showSnack}
            />
          </Stack>

          <WhatsappConfig showSnack={showSnack} />
          <TelegramConfig showSnack={showSnack} />
          <EliminarCuenta showSnack={showSnack} />
        </Stack>
      </Container>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </Stack>
  );
};

export default EditProfileProducer;
